/**
 * The git handlers that live in useWorkspaces (App), for the places that are
 * not handed them as props — the request editor's History button (card 9) is
 * deep inside EditorPane → RequestBuilder. App registers them once; a caller
 * gets {} until then (and in the web build, where there is no git).
 *
 *   itemHistory(workspace, itemId) → { path, unsynced, versions, fileAt }
 *   putBack(workspace, path, content, mode)
 */
let actions = {};

export function registerGitActions(next) {
  actions = next || {};
}

export function gitActions() {
  return actions;
}
